"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5582],{

/***/ 5997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _useCountTimer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8739);



var useInfiniteMapEvents = function useInfiniteMapEvents(array) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    start: 0,
    end: 10
  }),
      arrIndexes = _useState[0],
      setArrIndexes = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(array.slice(arrIndexes.start, arrIndexes.end)),
      displayedArray = _useState2[0],
      setDisplayedArray = _useState2[1];

  var _useCountTimer = (0,_useCountTimer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(),
      count = _useCountTimer.count;

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (array.length > 0) {
      setDisplayedArray(array.slice(arrIndexes.start, arrIndexes.end));
    }
  }, [array]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var start = arrIndexes.start;
    var end = arrIndexes.end;

    if (arrIndexes.end >= array.length) {
      setArrIndexes({
        start: 0,
        end: 10
      });
    } else {
      setArrIndexes({
        start: end,
        end: end + 10
      });
    }

    var next10 = array.slice(arrIndexes.start, arrIndexes.end);
    setDisplayedArray(next10);
  }, [count]);
  return {
    displayedArray: displayedArray
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useInfiniteMapEvents);

/***/ }),

/***/ 2439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FlexComp_FlexComp; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/FlexComp/FlexComp.style.ts


var renderAlign = function renderAlign(alignItems) {
  switch (alignItems) {
    case "center":
      return "\n            align-items:center;\n          ";

    case "baseline":
      return "\n        align-items:baseline;\n          ";

    case "flex-start":
      return "\n        align-items:flex-start;\n          ";

    case "flex-end":
      return "\n        align-items:flex-end;\n          ";

    default:
      return "\n        align-items:center;\n      ";
  }
};

var renderJustify = function renderJustify(justifyContent) {
  switch (justifyContent) {
    case "center":
      return "\n            justify-content:center;\n          ";

    case "space-between":
      return "\n        justify-content:space-between;\n          ";

    default:
      return "\n        justify-content:center;\n      ";
  }
};

var renderDir = function renderDir(flexDirection) {
  switch (flexDirection) {
    case "row":
      return "\n            flex-direction:row;\n          ";

    case "column":
      return "\n        flex-direction:column;\n          ";

    default:
      return "\n        flex-direction:row;\n      ";
  }
};

var FlexCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FlexCompstyle__FlexCompStyle",
  componentId: "wnowqj-0"
})(["display:flex;position:relative;", " ", " ", " gap:var(--gap,0);flex:var(--flex);flex-shrink:var(--flexShrink,unset);margin:var(--flexMargin,unset);padding:var(--padding,0);border-bottom:var(--borderBottom,none);border-top:var(--borderTop,none);background:var(--bgColor,transparent);border-radius:var(--borderRadius,0);height:var(--tm-height,unset);width:var(--tm-width,unset);"], function (p) {
  return p.alignItems && "\n    ".concat(renderAlign(p.alignItems), "\n  ");
}, function (p) {
  return p.justifyContent && "\n    ".concat(renderJustify(p.justifyContent), "\n  ");
}, function (p) {
  return p.flexDirection && "\n    ".concat(renderDir(p.flexDirection), "\n  ");
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/FlexComp/FlexComp.tsx




var FlexComp = function FlexComp(_ref) {
  var children = _ref.children,
      flexDirection = _ref.flexDirection,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      gap = _ref.gap,
      margin = _ref.margin,
      borderBottom = _ref.borderBottom,
      borderTop = _ref.borderTop,
      padding = _ref.padding,
      flex = _ref.flex,
      bgColor = _ref.bgColor,
      borderRadius = _ref.borderRadius,
      height = _ref.height,
      alignSelf = _ref.alignSelf,
      flexShrink = _ref.flexShrink,
      handleClick = _ref.handleClick,
      width = _ref.width;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FlexCompStyle, {
    flexDirection: flexDirection,
    alignItems: alignItems,
    justifyContent: justifyContent,
    style: {
      "--gap": gap,
      "--flexMargin": margin,
      "--borderBottom": borderBottom,
      "--borderTop": borderTop,
      "--padding": padding,
      "--flex": flex,
      "--bgColor": bgColor,
      "--borderRadius": borderRadius,
      "--tm-height": height,
      "--alignSelf": alignSelf,
      "--flexShrink": flexShrink,
      "--tm-width": width
    },
    onClick: handleClick,
    children: children
  });
};

/* harmony default export */ var FlexComp_FlexComp = (FlexComp);

/***/ }),

/***/ 9395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ useMapData; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/MapComp/hooks/points.tsx



var pointType = {
  "forex-card-swipe": {
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.75 5C3.33579 5 3 5.33579 3 5.75V14.75C3 15.1642 3.33579 15.5 3.75 15.5H20.25C20.6642 15.5 21 15.1642 21 14.75V5.75C21 5.33579 20.6642 5 20.25 5H3.75ZM18 16.9999H10.5V18.4999H18V16.9999Z",
          fill: "#CEC041"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M4 6.82143C4 6.50584 4.16789 6.25 4.375 6.25H12.625C12.8321 6.25 13 6.50584 13 6.82143V13.6786C13 13.9942 12.8321 14.25 12.625 14.25H4.375C4.16789 14.25 4 13.9942 4 13.6786V6.82143Z",
          fill: "#A59A34"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M8.6149 7.21136H8.07739V13.4317H8.6149V7.21136Z",
          fill: "white"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M8.36164 13.0655C8.31612 13.0655 8.27061 13.0655 8.22509 13.0611C7.04388 12.9896 6.73611 12.1097 6.73611 11.6524H7.00487H7.27362C7.27362 11.7347 7.31263 12.4695 8.2576 12.5258C8.73442 12.5561 9.14189 12.3893 9.34128 12.0837C9.48866 11.8604 9.4995 11.5873 9.37379 11.3381C9.25459 11.1018 9.00534 10.9718 8.78644 10.8569L8.73009 10.8288C8.40715 10.6575 8.23593 10.5687 8.22292 10.5622C8.22292 10.5622 8.04954 10.4733 7.70926 10.2934L7.65508 10.2652C7.39499 10.1287 7.03738 9.94014 6.83798 9.55218C6.62124 9.12521 6.64509 8.65706 6.90083 8.26911C7.2086 7.80096 7.79162 7.54521 8.46567 7.58422C9.64688 7.65574 9.95465 8.53569 9.95465 8.993H9.41714C9.41714 8.91064 9.37813 8.17808 8.43316 8.11956C7.95417 8.09138 7.54888 8.2561 7.34948 8.5617C7.2021 8.78494 7.19126 9.05802 7.31697 9.30727C7.43617 9.54351 7.68542 9.67356 7.90432 9.78843L7.96067 9.81877C8.28578 9.99216 8.457 10.0789 8.46784 10.0854C8.46784 10.0854 8.64122 10.1742 8.9815 10.3541L9.03569 10.3823C9.29794 10.5188 9.65555 10.7074 9.85278 11.0975C10.0695 11.5245 10.0457 11.9926 9.78993 12.3806C9.50383 12.8162 8.975 13.0698 8.36164 13.0698V13.0655Z",
          fill: "white"
        })]
      })
    }),
    type: "Forex Card Swipe",
    bgColorProp: "rgba(206, 192, 65, 0.2);",
    borderColorProp: "#CEC041",
    colorCode: "#CEC041"
  },
  "card-or-currency-order": {
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z",
          fill: "#CEC041"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M18.2726 11.9988C18.2726 15.4613 15.4661 18.2709 12.0036 18.2709C8.54106 18.2709 5.73145 15.4582 5.73145 11.9988C5.73145 11.6832 5.7562 11.3738 5.79952 11.0705C6.25129 8.0443 8.85668 5.72668 12.0067 5.72668C15.1566 5.72668 17.762 8.05049 18.2076 11.0736C18.2509 11.3768 18.2757 11.6863 18.2757 11.9988H18.2726Z",
          fill: "#CEC041"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M18.2726 11.9988C18.2726 15.4613 15.4661 18.2709 12.0036 18.2709C8.54106 18.2709 5.73145 15.4582 5.73145 11.9988C5.73145 11.6832 5.7562 11.3738 5.79952 11.0705C6.25129 8.0443 8.85668 5.72668 12.0067 5.72668C15.1566 5.72668 17.762 8.05049 18.2076 11.0736C18.2509 11.3768 18.2757 11.6863 18.2757 11.9988H18.2726Z",
          fill: "black",
          fillOpacity: "0.2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.2798 8.04248H11.6098V15.7965H12.2798V8.04248Z",
          fill: "white"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.9641 15.3399C11.9074 15.3399 11.8506 15.3399 11.7939 15.3345C10.3214 15.2454 9.93779 14.1485 9.93779 13.5784H10.2728H10.6078C10.6078 13.6811 10.6565 14.597 11.8344 14.6672C12.4288 14.705 12.9367 14.497 13.1853 14.116C13.369 13.8378 13.3825 13.4973 13.2258 13.1866C13.0772 12.8922 12.7665 12.7301 12.4936 12.5869L12.4234 12.5517C12.0208 12.3383 11.8074 12.2275 11.7912 12.2194C11.7912 12.2194 11.575 12.1087 11.1509 11.8844L11.0833 11.8493C10.7591 11.6791 10.3133 11.444 10.0648 10.9604C9.7946 10.4282 9.82432 9.8446 10.1431 9.36099C10.5268 8.77741 11.2535 8.45861 12.0938 8.50724C13.5662 8.5964 13.9499 9.6933 13.9499 10.2634H13.2798C13.2798 10.1607 13.2312 9.24751 12.0533 9.17457C11.4562 9.13944 10.9509 9.34478 10.7024 9.72572C10.5187 10.004 10.5052 10.3444 10.6619 10.6551C10.8105 10.9496 11.1212 11.1117 11.394 11.2549L11.4643 11.2927C11.8695 11.5089 12.083 11.6169 12.0965 11.625C12.0965 11.625 12.3126 11.7358 12.7368 11.9601L12.8043 11.9952C13.1312 12.1654 13.577 12.4004 13.8229 12.8868C14.0931 13.419 14.0633 14.0026 13.7445 14.4862C13.3879 15.0292 12.7287 15.3453 11.9641 15.3453V15.3399Z",
          fill: "white"
        })]
      })
    }),
    type: "Forex Order",
    bgColorProp: "rgba(206, 192, 65, 0.2);",
    borderColorProp: "#CEC041",
    colorCode: "#CEC041"
  },
  "trip-insured": {
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
          id: "path-1-inside-1_25_2293",
          fill: "white",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0641 4.00079C9.99296 6.29258 6 5.40525 6 5.40525C6 5.40525 6.00012 10.9523 6 12.5055C5.99988 14.0586 7.40511 18.1261 12.0641 19.3097V19.31C12.0642 19.3099 12.0644 19.3099 12.0646 19.3098C12.0647 19.3098 12.0647 19.3098 12.0648 19.3099V19.3098C16.7237 18.1262 18.129 14.0587 18.1288 12.5056C18.1287 10.9524 18.1288 5.40535 18.1288 5.40535C18.1288 5.40535 14.1359 6.29268 12.0648 4.00089V4C12.0646 4.00015 12.0645 4.0003 12.0644 4.00045C12.0643 4.00033 12.0642 4.00022 12.0641 4.0001V4.00079Z"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0641 4.00079C9.99296 6.29258 6 5.40525 6 5.40525C6 5.40525 6.00012 10.9523 6 12.5055C5.99988 14.0586 7.40511 18.1261 12.0641 19.3097V19.31C12.0642 19.3099 12.0644 19.3099 12.0646 19.3098C12.0647 19.3098 12.0647 19.3098 12.0648 19.3099V19.3098C16.7237 18.1262 18.129 14.0587 18.1288 12.5056C18.1287 10.9524 18.1288 5.40535 18.1288 5.40535C18.1288 5.40535 14.1359 6.29268 12.0648 4.00089V4C12.0646 4.00015 12.0645 4.0003 12.0644 4.00045C12.0643 4.00033 12.0642 4.00022 12.0641 4.0001V4.00079Z",
          fill: "url(#paint0_linear_25_2293)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0641 4.00079C9.99296 6.29258 6 5.40525 6 5.40525C6 5.40525 6.00012 10.9523 6 12.5055C5.99988 14.0586 7.40511 18.1261 12.0641 19.3097V19.31C12.0642 19.3099 12.0644 19.3099 12.0646 19.3098C12.0647 19.3098 12.0647 19.3098 12.0648 19.3099V19.3098C16.7237 18.1262 18.129 14.0587 18.1288 12.5056C18.1287 10.9524 18.1288 5.40535 18.1288 5.40535C18.1288 5.40535 14.1359 6.29268 12.0648 4.00089V4C12.0646 4.00015 12.0645 4.0003 12.0644 4.00045C12.0643 4.00033 12.0642 4.00022 12.0641 4.0001V4.00079Z",
          fill: "black",
          fillOpacity: "0.2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M6 5.40525L6.17056 4.63775L5.21376 4.42513L5.21378 5.40527L6 5.40525ZM12.0641 4.00079L12.6474 4.52794L12.8503 4.30342V4.00079H12.0641ZM6 12.5055L6.78622 12.5055L6 12.5055ZM12.0641 19.3097H12.8503V18.6982L12.2577 18.5477L12.0641 19.3097ZM12.0641 19.31H11.2778V20.3182L12.2557 20.0725L12.0641 19.31ZM12.0646 19.3098L12.2553 18.5471L12.0641 18.4993L11.873 18.5473L12.0646 19.3098ZM12.0648 19.3099L11.8741 20.0726L12.851 20.3168V19.3099H12.0648ZM12.0648 19.3098L11.8712 18.5478L11.2786 18.6983V19.3098H12.0648ZM18.1288 12.5056L17.3426 12.5056L18.1288 12.5056ZM18.1288 5.40535L18.9151 5.40537L18.9151 4.42523L17.9583 4.63785L18.1288 5.40535ZM12.0648 4.00089H11.2786V4.30352L11.4815 4.52804L12.0648 4.00089ZM12.0648 4H12.851V1.95761L11.4815 3.47281L12.0648 4ZM12.0644 4.00045L11.4805 4.52697L12.0637 5.17372L12.6477 4.52764L12.0644 4.00045ZM12.0641 4.0001L12.6479 3.47358L11.2778 1.9542V4.0001H12.0641ZM6 5.40525C5.82944 6.17275 5.82971 6.17281 5.82998 6.17287C5.8301 6.1729 5.83039 6.17296 5.83061 6.17301C5.83107 6.17311 5.83158 6.17323 5.83215 6.17335C5.8333 6.1736 5.8347 6.17391 5.83634 6.17426C5.83961 6.17497 5.84386 6.17589 5.84905 6.17698C5.85944 6.17918 5.87362 6.18211 5.89143 6.18567C5.92702 6.19277 5.97712 6.20235 6.04028 6.21339C6.16647 6.23544 6.34542 6.26342 6.56529 6.28903C7.00336 6.34006 7.61258 6.38276 8.29574 6.34763C9.63579 6.27872 11.4061 5.90147 12.6474 4.52794L11.4807 3.47364C10.6509 4.3919 9.3892 4.71688 8.21499 4.77726C7.64103 4.80677 7.12256 4.77087 6.74723 4.72715C6.5604 4.70538 6.41122 4.68194 6.31096 4.66442C6.26089 4.65567 6.22318 4.64842 6.19927 4.64365C6.18732 4.64126 6.17883 4.6395 6.17398 4.63847C6.17156 4.63796 6.17005 4.63764 6.16947 4.63751C6.16918 4.63745 6.16912 4.63743 6.1693 4.63747C6.16939 4.63749 6.16954 4.63753 6.16975 4.63757C6.16985 4.6376 6.17006 4.63764 6.17011 4.63765C6.17032 4.6377 6.17056 4.63775 6 5.40525ZM6.78622 12.5055C6.78628 11.7289 6.78628 9.95382 6.78627 8.37292C6.78626 7.58246 6.78625 6.84054 6.78624 6.29623C6.78624 6.02408 6.78623 5.80133 6.78623 5.64662C6.78623 5.56927 6.78623 5.50892 6.78622 5.46791C6.78622 5.44741 6.78622 5.43174 6.78622 5.4212C6.78622 5.41592 6.78622 5.41193 6.78622 5.40926C6.78622 5.40793 6.78622 5.40692 6.78622 5.40625C6.78622 5.40591 6.78622 5.40566 6.78622 5.40549C6.78622 5.4054 6.78622 5.40534 6.78622 5.4053C6.78622 5.40526 6.78622 5.40524 6 5.40525C5.21378 5.40527 5.21378 5.40529 5.21378 5.40533C5.21378 5.40538 5.21378 5.40544 5.21378 5.40552C5.21378 5.40569 5.21378 5.40594 5.21378 5.40628C5.21378 5.40695 5.21378 5.40796 5.21378 5.4093C5.21378 5.41197 5.21378 5.41596 5.21378 5.42123C5.21378 5.43177 5.21378 5.44744 5.21378 5.46794C5.21378 5.50895 5.21378 5.5693 5.21378 5.64665C5.21378 5.80136 5.21379 6.02411 5.21379 6.29626C5.2138 6.84057 5.21381 7.58248 5.21382 8.37293C5.21384 9.95386 5.21384 11.7289 5.21378 12.5054L6.78622 12.5055ZM12.2577 18.5477C10.134 18.0081 8.77141 16.8214 7.9329 15.6009C7.0774 14.3557 6.78618 13.1034 6.78622 12.5055L5.21378 12.5054C5.2137 13.4607 5.62503 15.0186 6.63686 16.4914C7.66567 17.9888 9.33519 19.4276 11.8705 20.0717L12.2577 18.5477ZM11.2778 19.3097V19.31H12.8503V19.3097H11.2778ZM12.2557 20.0725L12.2562 20.0723L11.873 18.5473L11.8725 18.5474L12.2557 20.0725ZM12.2555 18.5471L12.2553 18.5471L11.8739 20.0726L11.8741 20.0726L12.2555 18.5471ZM11.2786 19.3098V19.3099H12.851V19.3098H11.2786ZM12.2584 20.0718C14.7936 19.4277 16.4632 17.9889 17.492 16.4915C18.5038 15.0187 18.9151 13.4608 18.9151 12.5055L17.3426 12.5056C17.3427 13.1035 17.0514 14.3558 16.1959 15.601C15.3574 16.8215 13.9949 18.0082 11.8712 18.5478L12.2584 20.0718ZM18.9151 12.5055C18.915 11.729 18.915 9.95396 18.915 8.37303C18.915 7.58258 18.915 6.84067 18.915 6.29636C18.915 6.02421 18.9151 5.80146 18.9151 5.64675C18.9151 5.5694 18.9151 5.50905 18.9151 5.46805C18.9151 5.44754 18.9151 5.43187 18.9151 5.42133C18.9151 5.41606 18.9151 5.41207 18.9151 5.4094C18.9151 5.40806 18.9151 5.40705 18.9151 5.40638C18.9151 5.40605 18.9151 5.40579 18.9151 5.40562C18.9151 5.40554 18.9151 5.40548 18.9151 5.40543C18.9151 5.40539 18.9151 5.40537 18.1288 5.40535C17.3426 5.40534 17.3426 5.40536 17.3426 5.4054C17.3426 5.40544 17.3426 5.40551 17.3426 5.40559C17.3426 5.40576 17.3426 5.40601 17.3426 5.40635C17.3426 5.40702 17.3426 5.40803 17.3426 5.40936C17.3426 5.41204 17.3426 5.41603 17.3426 5.4213C17.3426 5.43184 17.3426 5.44751 17.3426 5.46801C17.3426 5.50902 17.3426 5.56937 17.3426 5.64672C17.3426 5.80143 17.3426 6.02418 17.3426 6.29634C17.3426 6.84064 17.3426 7.58256 17.3426 8.37302C17.3426 9.95392 17.3426 11.729 17.3426 12.5056L18.9151 12.5055ZM18.1288 5.40535C17.9583 4.63785 17.9585 4.6378 17.9587 4.63775C17.9588 4.63774 17.959 4.6377 17.9591 4.63767C17.9593 4.63763 17.9594 4.63759 17.9595 4.63758C17.9597 4.63754 17.9597 4.63755 17.9594 4.63761C17.9588 4.63774 17.9573 4.63806 17.9549 4.63857C17.95 4.6396 17.9415 4.64136 17.9296 4.64375C17.9057 4.64852 17.868 4.65577 17.8179 4.66452C17.7176 4.68204 17.5684 4.70548 17.3816 4.72725C17.0063 4.77097 16.4878 4.80687 15.9138 4.77736C14.7396 4.71698 13.4779 4.392 12.6481 3.47374L11.4815 4.52804C12.7227 5.90157 14.493 6.27882 15.8331 6.34773C16.5163 6.38286 17.1255 6.34016 17.5636 6.28913C17.7834 6.26352 17.9624 6.23554 18.0886 6.21349C18.1517 6.20246 18.2018 6.19287 18.2374 6.18577C18.2552 6.18221 18.2694 6.17928 18.2798 6.17708C18.285 6.17599 18.2892 6.17508 18.2925 6.17437C18.2941 6.17401 18.2955 6.17371 18.2967 6.17345C18.2973 6.17333 18.2978 6.17321 18.2982 6.17311C18.2984 6.17306 18.2987 6.173 18.2989 6.17297C18.2991 6.17291 18.2994 6.17285 18.1288 5.40535ZM11.2786 4V4.00089H12.851V4H11.2786ZM12.6477 4.52764L12.6481 4.52719L11.4815 3.47281L11.4811 3.47325L12.6477 4.52764ZM12.6483 3.47392L12.6479 3.47358L11.4802 4.52662L11.4805 4.52697L12.6483 3.47392ZM11.2778 4.0001V4.00079H12.8503V4.0001H11.2778Z",
          fill: "black",
          mask: "url(#path-1-inside-1_25_2293)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M6 5.40525C6 5.40525 9.99388 6.29278 12.0648 4C12.0648 6.81051 12.0648 17.5348 12.0648 19.3099C7.40525 18.1265 5.99988 14.0587 6 12.5055C6.00012 10.9523 6 5.40525 6 5.40525Z",
          fill: "#41CEA4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M18.1288 5.40538C18.1288 5.40538 14.135 6.2929 12.0641 4.00012C12.0641 6.81063 12.0641 17.5349 12.0641 19.31C16.7236 18.1266 18.129 14.0588 18.1288 12.5056C18.1287 10.9524 18.1288 5.40538 18.1288 5.40538Z",
          fill: "#41CEA4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M18.1288 5.40538C18.1288 5.40538 14.135 6.2929 12.0641 4.00012C12.0641 6.81063 12.0641 17.5349 12.0641 19.31C16.7236 18.1266 18.129 14.0588 18.1288 12.5056C18.1287 10.9524 18.1288 5.40538 18.1288 5.40538Z",
          fill: "black",
          fillOpacity: "0.1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M9.62156 10.254L9.00158 10.8636L9.00157 10.8635C8.97361 10.8909 8.95795 10.9281 8.95795 10.9669C8.95795 11.0057 8.97361 11.043 9.00157 11.0703L11.3204 13.3503C11.3786 13.4074 11.4728 13.4074 11.531 13.3503L15.127 9.81474C15.1852 9.75766 15.1852 9.66495 15.127 9.60787L14.5072 8.99833C14.4793 8.97085 14.4414 8.95544 14.402 8.95544C14.3625 8.95544 14.3247 8.97085 14.2967 8.99833L11.4257 11.821L9.83197 10.254C9.77381 10.1969 9.67961 10.1969 9.62156 10.254Z",
          fill: "white"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
            id: "paint0_linear_25_2293",
            x1: "17.2407",
            y1: "17.0679",
            x2: "9.82712",
            y2: "14.1311",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#43E1A8"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#219393"
            })]
          })
        })]
      })
    }),
    type: "Trips Insured",
    bgColorProp: "rgba(207, 255, 241, 0.2)",
    borderColorProp: "#52FFCB",
    colorCode: "#52FFCB"
  },
  "travel-loan": {
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M17.8853 15.1596C17.8853 15.1596 16.9214 10.4176 13.2962 8.3222H10.7051C7.07939 10.4181 6.1155 15.1596 6.1155 15.1596C5.05528 20.6734 11.6429 19.9712 11.6429 19.9712H12.3574C12.3574 19.9712 18.945 20.6734 17.8848 15.1596H17.8853Z",
          fill: "#FF7F3F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M8.07526 5.23959C7.94078 5.06806 7.72854 4.69819 7.95935 4.52715C8.25991 4.30396 8.84948 4.54031 9.15505 4.62364C9.55495 4.73182 9.997 4.82879 10.4365 4.78445C10.8656 4.74108 11.3538 4.50961 11.7346 4.35952C12.1205 4.20748 12.5254 3.9341 12.9865 4.07201C13.4687 4.21674 13.6584 4.62656 14.2153 4.67773C15.1937 4.76788 15.7713 3.91558 16.6885 4.00671C17.1652 4.05398 17.1105 4.34246 16.8435 4.54079L13.2966 8.32178H10.7055L8.07526 5.23959Z",
          fill: "#FF7F3F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M10.9762 8.3222C10.9762 8.3222 9.78203 9.16914 9.40771 9.81579C9.40771 9.81579 11.0033 8.66722 11.8563 8.3222H10.9762Z",
          fill: "#FF7F3F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M10.9762 8.3222C10.9762 8.3222 9.78203 9.16914 9.40771 9.81579C9.40771 9.81579 11.0033 8.66722 11.8563 8.3222H10.9762Z",
          fill: "black",
          fillOpacity: "0.2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.3346 8.3222C11.3346 8.3222 12.2548 8.79538 12.7049 9.81579C12.7049 9.81579 12.6467 8.95521 12.1675 8.3222H11.3346Z",
          fill: "#FF7F3F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.3346 8.3222C11.3346 8.3222 12.2548 8.79538 12.7049 9.81579C12.7049 9.81579 12.6467 8.95521 12.1675 8.3222H11.3346Z",
          fill: "black",
          fillOpacity: "0.2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M9.60577 4.7306L11.3348 7.87127V4.52203C11.3017 4.53519 11.2686 4.54835 11.235 4.56151C11.229 4.56394 11.223 4.56638 11.2169 4.56833C11.1833 4.58148 11.1492 4.59415 11.1156 4.60682C11.1141 4.60731 11.1131 4.6078 11.1116 4.60829C11.0764 4.62096 11.0413 4.63363 11.0062 4.64581C10.9992 4.64825 10.9916 4.65068 10.9846 4.65312C10.957 4.66238 10.9294 4.67164 10.9018 4.68041C10.8923 4.68333 10.8833 4.68625 10.8737 4.68918C10.8421 4.69892 10.81 4.70818 10.7784 4.71696C10.7754 4.71793 10.7729 4.71842 10.7699 4.71939C10.7357 4.72865 10.7021 4.73693 10.6685 4.74473C10.6595 4.74668 10.6499 4.74863 10.6409 4.75058C10.6153 4.75594 10.5902 4.76081 10.5651 4.76569C10.5556 4.76763 10.5456 4.7691 10.536 4.77056C10.5029 4.77592 10.4698 4.78079 10.4372 4.78372C10.1577 4.81198 9.87672 4.78274 9.60628 4.73011L9.60577 4.7306Z",
          fill: "#FF7F3F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M9.60577 4.7306L11.3348 7.87127V4.52203C11.3017 4.53519 11.2686 4.54835 11.235 4.56151C11.229 4.56394 11.223 4.56638 11.2169 4.56833C11.1833 4.58148 11.1492 4.59415 11.1156 4.60682C11.1141 4.60731 11.1131 4.6078 11.1116 4.60829C11.0764 4.62096 11.0413 4.63363 11.0062 4.64581C10.9992 4.64825 10.9916 4.65068 10.9846 4.65312C10.957 4.66238 10.9294 4.67164 10.9018 4.68041C10.8923 4.68333 10.8833 4.68625 10.8737 4.68918C10.8421 4.69892 10.81 4.70818 10.7784 4.71696C10.7754 4.71793 10.7729 4.71842 10.7699 4.71939C10.7357 4.72865 10.7021 4.73693 10.6685 4.74473C10.6595 4.74668 10.6499 4.74863 10.6409 4.75058C10.6153 4.75594 10.5902 4.76081 10.5651 4.76569C10.5556 4.76763 10.5456 4.7691 10.536 4.77056C10.5029 4.77592 10.4698 4.78079 10.4372 4.78372C10.1577 4.81198 9.87672 4.78274 9.60628 4.73011L9.60577 4.7306Z",
          fill: "black",
          fillOpacity: "0.2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M9.15513 4.62359C9.119 4.61384 9.07886 4.60166 9.03571 4.58899L10.4702 6.72435L9.42056 4.69084C9.33024 4.66988 9.24143 4.64698 9.15462 4.62359H9.15513Z",
          fill: "#FF7F3F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M9.15513 4.62359C9.119 4.61384 9.07886 4.60166 9.03571 4.58899L10.4702 6.72435L9.42056 4.69084C9.33024 4.66988 9.24143 4.64698 9.15462 4.62359H9.15513Z",
          fill: "black",
          fillOpacity: "0.2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M16.8431 4.54077C17.1105 4.34244 17.1652 4.05395 16.6881 4.00668C15.8521 3.92384 15.2982 4.62361 14.4668 4.68062L12.553 8.32224H13.2956L16.8431 4.54077Z",
          fill: "#FF7F3F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M16.8431 4.54077C17.1105 4.34244 17.1652 4.05395 16.6881 4.00668C15.8521 3.92384 15.2982 4.62361 14.4668 4.68062L12.553 8.32224H13.2956L16.8431 4.54077Z",
          fill: "black",
          fillOpacity: "0.2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.7839 7.42365L14.2003 4.67574C13.9098 4.64504 13.7197 4.51688 13.5335 4.38141L12.7844 7.42365H12.7839Z",
          fill: "#FF7F3F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.7839 7.42365L14.2003 4.67574C13.9098 4.64504 13.7197 4.51688 13.5335 4.38141L12.7844 7.42365H12.7839Z",
          fill: "black",
          fillOpacity: "0.2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.50037 14.5002C8.50037 16.4302 10.0703 18.0002 12.0004 18.0002C13.9304 18.0002 15.5004 16.4302 15.5004 14.5002C15.5004 12.5703 13.9304 11.0002 12.0004 11.0002C10.0703 11.0002 8.50037 12.5703 8.50037 14.5002ZM8.93873 14.4996C8.93873 12.8173 10.3121 11.4486 12.0004 11.4486C13.6887 11.4486 15.062 12.8173 15.062 14.4996C15.062 16.1819 13.6887 17.5506 12.0004 17.5506C10.3121 17.5506 8.93873 16.1819 8.93873 14.4996ZM11.9286 16.7278L10.6439 14.9234H10.6433L10.814 14.4001C11.1235 14.3102 11.3419 14.1721 11.4961 14.0128H10.6819V13.3431H11.8221C11.846 13.1941 11.8448 13.0548 11.8356 12.943H10.6819V12.2733H13.0719V12.943H12.4706C12.4773 13.0605 12.4755 13.1973 12.4602 13.3431H13.0719V14.0128H12.276C12.2723 14.0206 12.2687 14.0283 12.2652 14.0359C12.2557 14.0562 12.2463 14.0763 12.2357 14.0963C12.0527 14.436 11.7762 14.6987 11.4104 14.881L12.8211 16.7278H11.9286Z",
          fill: "white"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M14.0017 8.19112C13.9857 8.19112 13.9696 8.18966 13.953 8.18576C12.645 7.90507 10.226 8.18624 10.2014 8.18917C10.0639 8.20525 9.93996 8.09658 9.9249 7.946C9.90985 7.79543 10.0097 7.65996 10.1472 7.64388C10.2495 7.63169 12.666 7.35052 14.0494 7.64729C14.1854 7.67653 14.2742 7.82028 14.2471 7.96891C14.2235 8.0995 14.1186 8.19014 14.0012 8.19014L14.0017 8.19112Z",
          fill: "#FF931E"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.8317 7.52203C11.79 7.5235 11.7484 7.52496 11.7072 7.52642C11.632 7.64289 11.5326 7.83245 11.4754 8.08731C11.51 8.08536 11.5451 8.08389 11.5808 8.08195C11.6475 7.80759 11.7644 7.6156 11.8317 7.52203Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.1192 7.55786C11.0766 7.56079 11.0354 7.56371 10.9948 7.56663C10.919 7.69236 10.8282 7.88387 10.7785 8.13434C10.8121 8.13142 10.8472 8.12898 10.8829 8.12606C10.9406 7.86096 11.0464 7.66702 11.1187 7.55835L11.1192 7.55786Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.4775 7.53668C11.4354 7.53863 11.3937 7.54107 11.3531 7.5435C11.2773 7.66436 11.1815 7.85489 11.1278 8.1078C11.1619 8.10537 11.1971 8.10342 11.2322 8.10098C11.2949 7.83004 11.4073 7.63755 11.4775 7.53668Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M10.7581 7.58484C10.715 7.58825 10.6738 7.59215 10.6342 7.59556C10.5589 7.72664 10.4731 7.91864 10.4285 8.1657C10.4606 8.16278 10.4952 8.15937 10.5333 8.15547C10.585 7.89623 10.6839 7.70179 10.7581 7.58484Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M10.2708 7.63077C10.2 7.76137 10.1243 7.94362 10.0836 8.17217C10.1142 8.18532 10.1478 8.19215 10.183 8.19068C10.2281 7.93729 10.3194 7.74285 10.3942 7.6181C10.347 7.62298 10.3054 7.62687 10.2708 7.63077Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M13.8378 7.60769C13.8027 7.60185 13.7666 7.59649 13.7304 7.59113C13.6592 7.71393 13.5789 7.8913 13.5317 8.11741C13.5654 8.12131 13.599 8.1257 13.6316 8.13008C13.6813 7.8991 13.7676 7.72221 13.8373 7.60769H13.8378Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M14.05 7.64782C14.05 7.64782 14.046 7.64685 14.044 7.64636C13.9757 7.77501 13.9055 7.95044 13.8663 8.16826C13.8959 8.17362 13.925 8.17947 13.9531 8.18581C13.9572 8.18678 13.9607 8.18629 13.9647 8.18727C14.0023 7.97822 14.0716 7.80912 14.1363 7.68632C14.1107 7.66829 14.0816 7.65465 14.0495 7.64782H14.05Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M13.1967 7.53709C13.158 7.53466 13.1194 7.53222 13.0808 7.52979C13.0075 7.64381 12.9132 7.82607 12.8555 8.06874C12.8901 8.06972 12.9242 8.07118 12.9583 8.07264C13.0221 7.81681 13.1289 7.63407 13.1967 7.53661V7.53709Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M13.5211 7.5651C13.484 7.5612 13.4468 7.55731 13.4092 7.55389C13.3364 7.67182 13.2481 7.85115 13.1949 8.08652C13.2291 8.08895 13.2627 8.09139 13.2963 8.09431C13.354 7.85066 13.4513 7.67085 13.5206 7.56559L13.5211 7.5651Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.8644 7.52026C12.8248 7.51879 12.7851 7.51782 12.7455 7.51685C12.6717 7.62844 12.5729 7.81264 12.5132 8.06214C12.5478 8.06214 12.5824 8.06263 12.617 8.06311C12.6853 7.79753 12.7992 7.6109 12.8644 7.52026Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.4043 7.51221C12.33 7.6238 12.2292 7.80995 12.1689 8.06335C12.2036 8.06286 12.2387 8.06237 12.2733 8.06189C12.3431 7.78948 12.4615 7.60041 12.5257 7.51269C12.4851 7.51269 12.4449 7.51221 12.4043 7.51221Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.1815 7.51349C12.1404 7.51398 12.0992 7.51495 12.0586 7.51544C11.9838 7.62849 11.883 7.81659 11.8232 8.07194C11.8579 8.07096 11.893 8.0695 11.9281 8.06853C11.9974 7.79369 12.1163 7.60267 12.1815 7.51349Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          style: {
            mixBlendMode: "multiply",
            opacity: "0.8"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M14.0016 7.95726C13.9856 7.95726 13.9695 7.9558 13.953 7.9519C12.6449 7.67122 10.2259 7.95239 10.2013 7.95532C10.0924 7.96799 9.99206 7.9022 9.9474 7.79987C9.92833 7.84421 9.9193 7.89392 9.92482 7.94606C9.93987 8.09663 10.0638 8.2053 10.2013 8.18922C10.2254 8.1863 12.6444 7.90512 13.953 8.18581C13.9695 8.18922 13.9856 8.19117 14.0016 8.19117C14.119 8.19117 14.2239 8.10053 14.2475 7.96993C14.258 7.91 14.2495 7.85152 14.2274 7.80035C14.1863 7.89538 14.0985 7.95775 14.0016 7.95775V7.95726Z",
            fill: "#B3B3B3"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M14.0017 8.7419C13.9857 8.7419 13.9696 8.74044 13.953 8.73654C12.645 8.45585 10.226 8.73703 10.2014 8.73995C10.0639 8.75603 9.93996 8.64736 9.9249 8.49679C9.90985 8.34621 10.0097 8.21074 10.1472 8.19466C10.2495 8.18247 12.666 7.9013 14.0494 8.19807C14.1854 8.22731 14.2742 8.37106 14.2471 8.51969C14.2235 8.65029 14.1186 8.74092 14.0012 8.74092L14.0017 8.7419Z",
          fill: "#FF931E"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.8317 8.07294C11.79 8.0744 11.7484 8.07586 11.7072 8.07732C11.632 8.19379 11.5326 8.38335 11.4754 8.63821C11.51 8.63626 11.5451 8.6348 11.5808 8.63285C11.6475 8.3585 11.7644 8.1665 11.8317 8.07294Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.1192 8.1087C11.0766 8.11163 11.0354 8.11455 10.9948 8.11748C10.919 8.2432 10.8282 8.43471 10.7785 8.68518C10.8121 8.68226 10.8472 8.67982 10.8829 8.6769C10.9406 8.41181 11.0464 8.21786 11.1187 8.10919L11.1192 8.1087Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.4775 8.08777C11.4354 8.08972 11.3937 8.09215 11.3531 8.09459C11.2773 8.21544 11.1815 8.40598 11.1278 8.65889C11.1619 8.65645 11.1971 8.6545 11.2322 8.65207C11.2949 8.38113 11.4073 8.18864 11.4775 8.08777Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M10.7581 8.13568C10.715 8.13909 10.6738 8.14299 10.6342 8.1464C10.5589 8.27749 10.4731 8.46948 10.4285 8.71655C10.4606 8.71362 10.4952 8.71021 10.5333 8.70631C10.585 8.44707 10.6839 8.25263 10.7581 8.13568Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M10.2708 8.18168C10.2 8.31227 10.1243 8.49452 10.0836 8.72307C10.1142 8.73623 10.1478 8.74305 10.183 8.74159C10.2281 8.48819 10.3194 8.29376 10.3942 8.16901C10.347 8.17388 10.3054 8.17778 10.2708 8.18168Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M13.8378 8.15921C13.8027 8.15336 13.7666 8.148 13.7304 8.14264C13.6592 8.26544 13.5789 8.44282 13.5317 8.66893C13.5654 8.67283 13.599 8.67721 13.6316 8.6816C13.6813 8.45061 13.7676 8.27372 13.8373 8.15921H13.8378Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M14.05 8.19873C14.05 8.19873 14.046 8.19775 14.044 8.19727C13.9757 8.32591 13.9055 8.50134 13.8663 8.71917C13.8959 8.72453 13.925 8.73038 13.9531 8.73671C13.9572 8.73769 13.9607 8.7372 13.9647 8.73817C14.0023 8.52912 14.0716 8.36003 14.1363 8.23722C14.1107 8.21919 14.0816 8.20555 14.0495 8.19873H14.05Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M13.1967 8.088C13.158 8.08556 13.1194 8.08312 13.0808 8.08069C13.0075 8.19472 12.9132 8.37697 12.8555 8.61965C12.8901 8.62062 12.9242 8.62208 12.9583 8.62354C13.0221 8.36771 13.1289 8.18497 13.1967 8.08751V8.088Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M13.5211 8.11594C13.484 8.11205 13.4468 8.10815 13.4092 8.10474C13.3364 8.22266 13.2481 8.40199 13.1949 8.63736C13.2291 8.6398 13.2627 8.64223 13.2963 8.64516C13.354 8.4015 13.4513 8.22169 13.5206 8.11643L13.5211 8.11594Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.8644 8.0711C12.8248 8.06964 12.7851 8.06866 12.7455 8.06769C12.6717 8.17928 12.5729 8.36348 12.5132 8.61298C12.5478 8.61298 12.5824 8.61347 12.617 8.61396C12.6853 8.34837 12.7992 8.16174 12.8644 8.0711Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.4043 8.06311C12.33 8.1747 12.2292 8.36085 12.1689 8.61425C12.2036 8.61376 12.2387 8.61328 12.2733 8.61279C12.3431 8.34039 12.4615 8.15131 12.5257 8.0636C12.4851 8.0636 12.4449 8.06311 12.4043 8.06311Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.1815 8.06433C12.1404 8.06482 12.0992 8.06579 12.0586 8.06628C11.9838 8.17933 11.883 8.36743 11.8232 8.62278C11.8579 8.62181 11.893 8.62034 11.9281 8.61937C11.9974 8.34453 12.1163 8.15351 12.1815 8.06433Z",
          fill: "#BF6E17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          style: {
            mixBlendMode: "multiply",
            opacity: "0.8"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M14.0016 8.50829C13.9856 8.50829 13.9695 8.50683 13.953 8.50293C12.6449 8.22224 10.2259 8.50342 10.2013 8.50634C10.0924 8.51901 9.99206 8.45322 9.9474 8.35089C9.92833 8.39524 9.9193 8.44494 9.92482 8.49708C9.93987 8.64766 10.0638 8.75633 10.2013 8.74025C10.2254 8.73732 12.6444 8.45615 13.953 8.73684C13.9695 8.74025 13.9856 8.7422 14.0016 8.7422C14.119 8.7422 14.2239 8.65156 14.2475 8.52096C14.258 8.46102 14.2495 8.40255 14.2274 8.35138C14.1863 8.4464 14.0985 8.50878 14.0016 8.50878V8.50829Z",
            fill: "#B3B3B3"
          })
        })]
      })
    }),
    type: "Travel Loans",
    bgColorProp: "rgba(255, 127, 63, 0.2);",
    borderColorProp: "#FF7F3F",
    colorCode: "#FF7F3F"
  }
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/constants/index.ts + 2 modules
var constants = __webpack_require__(9753);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/MapComp/hooks/useMapData.tsx



var useMapData = function useMapData() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;

  var _useState = (0,react.useState)([]),
      mapPoints = _useState[0],
      setMapPoints = _useState[1];

  (0,react.useEffect)(function () {
    fetch("".concat(constants/* API.GET_MAP_DATA */.bl.GET_MAP_DATA)).then(function (res) {
      return res.json();
    }).then(function (data) {
      var events = data === null || data === void 0 ? void 0 : data.data;

      if (events) {
        for (var i = 0; i < events.length; i++) {
          var event = events[i];
          event["event_name"] = pointType[event.eventName];
        }

        setMapPoints(events);
      }
    });
  }, []);
  return [mapPoints];
};

/***/ }),

/***/ 9808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8059);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);




var H6Tag = function H6Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .H6TagStyle */ .xT, {
    style: {
      "--color": color,
      "--margin": margin
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (H6Tag);

/***/ }),

/***/ 2348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8059);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2322);


var _excluded = ["fontSize", "fontWeight", "color", "textAlign", "margin", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SpanTag = function SpanTag(_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "black" : _ref$color,
      textAlign = _ref.textAlign,
      margin = _ref.margin,
      children = _ref.children,
      rest = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .SpanTagStyle */ .zs, _objectSpread(_objectSpread({
    margin: margin,
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color
  }, rest), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (SpanTag);

/***/ }),

/***/ 8059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xT": function() { return /* binding */ H6TagStyle; },
/* harmony export */   "zs": function() { return /* binding */ SpanTagStyle; }
/* harmony export */ });
/* unused harmony exports H1TagStyle, H2TagStyle, H3TagStyle, H4TagStyle, H5TagStyle, ParaTagStyle, AnchorTagStyle, CliptextStyleComp */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);


var renderFont = function renderFont(fontSize) {
  switch (fontSize) {
    case "xxs":
      return "\n          font-size: 10px;\n          line-height: 16px;\n        ";

    case "xs":
      return "\n          font-size: 12px;\n          line-height: 16px;\n        ";

    case "sm":
      return "\n          font-size: 14px;\n          line-height: 20px;\n        ";

    case "md":
      return "\n        font-size: 16px;\n        line-height: 24px;\n      ";

    case "large":
      return "\n          font-size: 18px;\n          line-height: 26px;\n        ";

    case "xlarge":
      return "\n        font-size: 22px;\n        line-height: 32px;\n      ";

    case "xxlarge":
      return "\n        font-size: 24px;\n        line-height: 32px;\n      ";

    case "xxxlarge":
      return "\n        font-size: 28px;\n        line-height: 32px;\n      ";

    default:
      return "\n      font-size: 14px;\n      line-height: 20px;\n    ";
  }
};

var renderFontWeight = function renderFontWeight(fontWeight) {
  switch (fontWeight) {
    case "regular":
      return "\n          font-weight: 400;\n        ";

    case "medium":
      return "\n        font-weight: 500;\n      ";

    case "semiBold":
      return "\n        font-weight: 600;\n      ";

    case "bold":
      return "\n        font-weight: 700;\n      ";

    case "black":
      return "\n      font-weight: 900;\n        ";

    default:
      return "\n      font-weight: 400;\n    ";
  }
};

var H1TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({
  displayName: "TextStylesstyle__H1TagStyle",
  componentId: "aknq6f-0"
})(["font-size:56px;line-height:72px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#4a4a4a);span{font-size:56px;line-height:72px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#4a4a4a);}"]);
var H2TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h2.withConfig({
  displayName: "TextStylesstyle__H2TagStyle",
  componentId: "aknq6f-1"
})(["font-size:48px;line-height:64px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#4a4a4a);"]);
var H3TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({
  displayName: "TextStylesstyle__H3TagStyle",
  componentId: "aknq6f-2"
})(["font-size:40px;line-height:54px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#4a4a4a);text-align:var(--textAlign,left);"]);
var H4TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h4.withConfig({
  displayName: "TextStylesstyle__H4TagStyle",
  componentId: "aknq6f-3"
})(["font-size:32px;line-height:40px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#4a4a4a);"]);
var H5TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h5.withConfig({
  displayName: "TextStylesstyle__H5TagStyle",
  componentId: "aknq6f-4"
})(["font-size:24px;line-height:32px;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#4a4a4a);font-weight:var(--fontWeight,500);span{font-size:24px;line-height:32px;font-family:\"Raleway\";font-weight:var(--fontWeight,500);}"]);
var H6TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h6.withConfig({
  displayName: "TextStylesstyle__H6TagStyle",
  componentId: "aknq6f-5"
})(["font-size:16px;line-height:25px;font-weight:var(--fontWeight,500);margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#4a4a4a);"]);
var ParaTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
  displayName: "TextStylesstyle__ParaTagStyle",
  componentId: "aknq6f-6"
})(["font-family:\"Open Sans\";", " ", " margin:", ";text-align:", ";color:", ";"], function (p) {
  return p.fontSize ? "\n    ".concat(renderFont(p.fontSize), "\n  ") : "";
}, function (p) {
  return p.fontWeight && "\n    ".concat(renderFontWeight(p.fontWeight), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.color && p.color;
});
var SpanTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
  displayName: "TextStylesstyle__SpanTagStyle",
  componentId: "aknq6f-7"
})(["font-family:\"Open Sans\";", " ", " color:", ";margin:", ";text-align:", ";display:inline-block;"], function (p) {
  return p.fontSize && "\n    ".concat(renderFont(p.fontSize), "\n  ");
}, function (p) {
  return p.fontWeight && "\n    ".concat(renderFontWeight(p.fontWeight), "\n  ");
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
});
var AnchorTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].a.withConfig({
  displayName: "TextStylesstyle__AnchorTagStyle",
  componentId: "aknq6f-8"
})(["font-family:\"Open Sans\";", " ", " margin:", ";display:inline-block;color:", ";text-align:", ";"], function (p) {
  return p.fontSize && "\n    ".concat(renderFont(p.fontSize), "\n  ");
}, function (p) {
  return p.fontWeight && "\n    ".concat(renderFontWeight(p.fontWeight), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.textAlign && p.textAlign;
});
var CliptextStyleComp = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "TextStylesstyle__CliptextStyleComp",
  componentId: "aknq6f-9"
})(["background:linear-gradient( 92.2deg,#ffe2e8 0.47%,#fffcfc 25.07%,#8cc8ea 64.68% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;width:fit-content;font-weight:600;"]);

/***/ })

}]);